<template>
    <BaseInput :error="error" :required="required" :append-text="appendText" :labelWidth="labelWidth">
        <template slot="label">
            {{ label }}
        </template>
        <template slot="input">
            <select :value="value" v-model="currentOption" @change="updateValue" :disabled="disabled">
                <slot name="noneValue"><option :value="null">---</option></slot>
                <option v-for="option in options" :key="option.value || option" :value="option.value || option">
                    {{ option.label || option }}
                </option>
            </select>
        </template>
    </BaseInput>
</template>

<script>
import FormValidator from "@/mixins/FormValidator";
import BaseInput from "@/components/ui/Form/BaseInput";

export default {
    data: () => ({
        currentOption: undefined,
        localErrorMessage: undefined
    }),
    components: {
        BaseInput
    },
    watch: {
        value(newValue) {
            this.currentOption = newValue;
        }
    },
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        value: {
            required: true
        },
        label: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        errorMessage: {
            type: String,
            required: false
        },
        enableValidation: {
            type: Boolean,
            required: false,
            default: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        appendText: {
            type: String,
            required: false,
            default: null
        },
        labelWidth: {
            type: Number,
            required: false,
            default: null
        }
    },
    mixins: [FormValidator],
    computed: {
        error() {
            return this.errorMessage || this.localErrorMessage;
        }
    },
    methods: {
        updateValue($event) {
            this.localErrorMessage = undefined;
            const value = $event.target.value.trim();
            this.$emit("change", value);
            if (this.enableValidation) {
                const inputValid = this.validInput(value);
                if (inputValid !== true) {
                    this.localErrorMessage = inputValid;
                }
            }
        }
    },
    mounted() {
        this.currentOption = this.value;
    }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";

label {
    font-family: Roboto, sans-serif;
    font-weight: bold;
    font-size: 1.17em;
}
input {
    font-size: 16px;
    border: 1px solid #333333;
    @extend %primary-border-color;
    background-color: #fff;
    border-radius: 5px;
    width: 100%;
    padding: 7px;
}
.color-circle {
    display: inline-block;
    vertical-align: middle;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin: 0px 5px;
}
</style>



// WEBPACK FOOTER //
// SelectBloc.vue?5fbc4df0